import * as types from './actionTypes';

export function ArmazenaNavegacaoSuccess(navegacao) {
    
    return { type: types.ARMAZENA_NAVEGACAO, navegacao }
}

export function ArmazenaNavegacao(navegacao) {
    
    return function (dispatch) {
        return dispatch(ArmazenaNavegacaoSuccess(navegacao));
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/navegacaoActions.js
 **/